import React, { useEffect, useRef, useState } from 'react'
import DatePickerSS from '../../../../../../DatePickerSS/DatePickerSS';
import './RecommendationSS.css'
import CustomButtonSS from '../../../../../../Common/CustomButton/CustomButtonSS';
import { useDispatch } from 'react-redux';
import { smartScheduleSelector } from '../../../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
import { useSelector } from 'react-redux';
import { getUserSelector } from '../../../../../../../../redux/reducers/reducerSlices/UserReducer';
import moment from 'moment';
import { AppConstant } from '../../../../../../../Assests/AppConstant';
import _ from 'lodash';
import { calculateDateRanges, customStylesLight, formParticularFieldValue, showAlert } from '../../../../../../../Assests/Utility';
import { sagaActions } from '../../../../../../../../sagas/sagaActions';
import RecommendedTimeslotSS from './RecommendedTimeslotSS';
import Loader from '../../../../../../Loader/Loader';
import { CustomDynamicFormSS } from '../../../../../../Common/CustomForm/CustomDynamicFormSS';
import { getWhMetaDataReducerSlice } from '../../../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import CustomFieldWithTtileSS from '../../../../../../Common/CustomField/CustomFieldWithTtileSS';
import SSPopup from '../../../../../../Common/Popup/SSPopup/SSPopup';
import { toast } from 'react-toastify';
import SelectRescheuleReason from '../../../../../../LandingPage/SmartScheduler/BookAppointments/Components/SelectReasonForRescheduleOrCancel/SelectRescheuleReason';

export const RecommendationSS = (props) => {
    const { isCarrier, themeSelected,handleOptionChangeParent,rescheduleReason=null, setSelectedOption } = props;
    const dispatch = useDispatch();
    const [selectedDate, setSelectedDate] = useState(null);
    const [requestedTime, setRequestedTime] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [dueDate, setDueDate] = useState(null);
    const [dueDateStr, setDueDateStr] = useState(null);
    const [showDueDateDisclaimer, setShowDueDateDisclaimer] = useState(false);
    const [dueDateDisclaimerType, setDueDateDisclaimerType] = useState(null); // 'pre' or 'post'
    const [overdueBookingAllowedDays, setOverdueBookingAllowedDays] = useState(0);
    const [overdueBookingAllowed, setOverdueBookingAllowed] = useState(false);
    const [timeSlot, setTimeSlot] = useState(null)
    const ssReducer = useSelector(smartScheduleSelector);
    const { ssRecommendationsArr, poForAppt, appointmentList, intiateAppointmentLoading, carrierList, appointmentConfirmation, dateValidationResponse, appointmentDocumentsList, vehicleAndLoadType } = ssReducer;
    const whMetaData = useSelector(getWhMetaDataReducerSlice);
    const { whMetaDocksList } = whMetaData;
    const [recommendationsArr, setRecommendationsArr] = useState([]);
    const user = useSelector(getUserSelector);
    const { cu_id, userAccountDetails, addCarrierSpro, userType } = user;
    const [loading, setLoading] = useState(false);
    const [SelectReccSlot, setSelectReccSlot] = useState({});
    const [timezone, setTimezone] = useState('')
    const [errorMsg, setErrorMsg] = useState(null);
    const [carrierListState, setCarrierListState] = useState([]);
    const [selectedCarrier, setSelectedCarrier] = useState(null);
    const [particularFieldValue, setParticularFieldValue] = useState("");
    const [timeZoneText, setTimeZoneText] = useState('')
    const todayDate = new Date();
    const [nextStep, setNextStep] = useState(false)
    const [resetFormData, setResetFormData] = useState(0);
    const [searchableSelectFormData, setSearchableSelectFormData] = useState(null)
    const [earliestInfo, setEarliestInfo] = useState(null);
    const [carrierSCAC, setCarrierSCAC] = useState("");
    const [isScacDisabled, setIsScacDisabled] = useState(false);
    const [overDueWindowReason, setOverDueWindowReason] = useState(null);
    const [showOverDueWindowReasonPopup, setShowOverDueWindowReasonPopup] = useState(false);
    const [showReasonCodeWindow, setShowReasonCodeWindow] = useState(0);
    const [showReasonCodeWindowPost, setShowReasonCodeWindowPost] = useState(0);
     // Standing slots state
     const [showStandingPopup, setShowStandingPopup] = useState(false);
     const [standingSlots, setStandingSlots] = useState([]);
     const [standingPopupDismissed, setStandingPopupDismissed] = useState(false);
     const [pendingStandingSubmit, setPendingStandingSubmit] = useState(false);
     const hasInitialFetchDone = useRef(false);
    // const formTime = (dateStr) => {
    //     // Combine the date and time strings
    //     const combinedDateTimeStr = `${dateStr}`;
    //     const masterPO = poForAppt[0];
    //     // Parse the string into a moment object in MST timezone
    //     const originalMoment = moment.tz(combinedDateTimeStr, AppConstant.commonStrings.MM_DD_YYYY__HH_mm_ss, masterPO?.WarehouseData?.TimeZone);
    //     // Create a JavaScript Date object from the moment object
    //     // const newDate = momentObj.toDate();
    //     return originalMoment.utc();
    // }

    // useEffect(() => {
    //     // setLoading(true)
    //     setSearchableSelectFormData(null)
    //     setParticularFieldValue({})
    //     setSelectedCarrier(null)
    //     setEarliestInfo(null);
    //     if (!_.isEmpty(addCarrierSpro)) {
    //         dispatch({type: sagaActions.ADD_CARRIER_SCHEDULE_PRO, payload: {type: 'C'}})
    //     }
    //     if (poForAppt && poForAppt.length) {
    //         let apptLeadTime = 0; // Lead time in hours 
    //         const masterPO = poForAppt[0];
    //         const filterDock = whMetaDocksList.filter(el => el?.ID === masterPO?.IDDock);
    //         let OverdueBookingAllowedDays = 0;
    //         let OverdueBookingAllowed = false;
    //         if (_.size(filterDock)) {
    //             apptLeadTime = filterDock[0]?.ApptLifeTime;
    //             OverdueBookingAllowedDays = filterDock[0]?.OverdueBookingAllowedDays || 0;
    //             OverdueBookingAllowed = filterDock[0]?.OverdueBookingAllowed || false;
    //         }
    //         setOverdueBookingAllowedDays(OverdueBookingAllowedDays);
    //         setOverdueBookingAllowed(OverdueBookingAllowed);
    //         if (masterPO?.IDCarrier) {
    //             setSelectedCarrier({
    //                 label: masterPO?.CarrierName,
    //                     value: masterPO?.IDCarrier,
    //             })
    //         setSearchableSelectFormData({
    //             label: masterPO?.CarrierName,
    //                 value: masterPO?.IDCarrier,
    //         })
    //         setParticularFieldValue({ carrier_name: masterPO?.IDCarrier})
              
    //         }
    //         // if (isCarrier() && poForAppt.length && poForAppt[0]?.AppointmentBookStartTime) {
    //         //     const dateData = moment(poForAppt[0]?.AppointmentBookStartTime).utc();
    //         //     const tempMaxDate = moment(poForAppt[0]?.AppointmentBookEndTime).utc();
    //         //     setSelectedDate(new Date(dateData.year(), dateData.month(), dateData.date()))
    //         //     setMinDate(new Date(dateData.year(), dateData.month(), dateData.date()))
    //         //     setMaxDate(new Date(tempMaxDate.year(), tempMaxDate.month(), tempMaxDate.date()))
    //         //     setRequestedTime(moment(dateData).format(AppConstant.commonStrings.HH_mm_dateFormat))                
    //         // } else {
                
    //         //     const dateData = moment(todayDate).utc();
    //         //     const tempMaxDate = moment(masterPO.DueDate).utc();
    //         //     console.log(dateData, tempMaxDate, dateData < tempMaxDate)
    //         //     setSelectedDate(new Date(dateData.year(), dateData.month(), dateData.date()))
    //         //     setMinDate(new Date(dateData.year(), dateData.month(), dateData.date()))
    //         //     setMaxDate(new Date(tempMaxDate.year(), tempMaxDate.month(), tempMaxDate.date()))
    //         //     setRequestedTime(moment(todayDate).format(AppConstant.commonStrings.HH_mm_dateFormat)) 
    //         // }
            
    //         const todayDate = moment().utc();
    //         if (isCarrier() && poForAppt.length && poForAppt[0]?.AppointmentBookStartTime) {
               
    //             const appointmentBookStartTime = poForAppt[0]?.AppointmentBookStartTime ? moment(poForAppt[0]?.AppointmentBookStartTime).utc(): null;
    //              const warehouseTimeZone = poForAppt[0]?.WarehouseData?.TimeZone;
    //              const dueDateString = moment.utc(poForAppt[0]?.DueDate).format(AppConstant.commonStrings.YYYY_MM_DD);
    //              const dueDate = moment.tz(dueDateString, warehouseTimeZone);
    //             setDueDate(dueDate);
    //             setDueDateStr(dueDateString)
    //             // new logic - for carrier no need to consider appointment life time
    //             let maxDate = dueDate.endOf('day');
    //             if (OverdueBookingAllowed) {
    //                 maxDate = moment(dueDate).add(OverdueBookingAllowedDays, 'days');
    //             }
    //             let minDate
    //             // Determine maxDate based on the logic
    //             // let maxDate;
    //             // // if dueDate and apptStartTime are same
    //             // if (dueDate.isSameOrAfter(apptStartTime)) {
    //             //     // if dueDate is same or after todayDate - bascically dueDate is in future
    //             //     if (dueDate.isSameOrAfter(todayDate)) {
    //             //         maxDate = dueDate.endOf('day'); // Due date is used
    //             //     } else {
    //             //         // if dueDate is before todayDate - bascically dueDate is in past
    //             //         maxDate = moment(apptStartTime).add(apptLeadTime, 'hours').endOf('day'); // 
    //             //     }
    //             // } else {
    //             //     // Unscheduled orders - Consider DueDate
    //             //     if (!apptStartTime) {
    //             //         maxDate = dueDate.endOf('day'); // Due date is used
    //             //     } else {
    //             //         maxDate = moment(apptStartTime).add(apptLeadTime, 'hours').endOf('day'); // Appointment start + lead time
    //             //     }
                    
    //             // }
    //         //  SPRO-100 - Instead of today date chnaged to apptStartTime
    //             if (appointmentBookStartTime.startOf('day').isSameOrAfter(todayDate.startOf('day'))) {
    //                 minDate = appointmentBookStartTime.startOf('day')
    //             } else {
    //                 minDate = todayDate.startOf('day')
    //             }
    //             setSelectedDate(new Date(minDate.year(), minDate.month(), minDate.date()));
    //             setMinDate(new Date(minDate.year(), minDate.month(), minDate.date()));
    //             setMaxDate(new Date(maxDate.year(), maxDate.month(), maxDate.date(), 23, 59, 59));
    //             setRequestedTime(moment(minDate).format(AppConstant.commonStrings.HH_mm_dateFormat));
    //         } else {
    //             const apptStartTime = poForAppt[0]?.ApptStartTime? moment(poForAppt[0]?.ApptStartTime).utc(): null;
    //             let dueDate;
    //             if (poForAppt.length > 1 && _.size(filterDock) && filterDock[0]?.AppointmentDueDateType === 'EARLIEST') {
    //                 const earliestPO = poForAppt.reduce((earliest, po) => {
    //                     return moment(po.DueDate).utc().isBefore(moment(earliest.DueDate).utc()) ? po : earliest;
    //                 }, poForAppt[0]);
    //                 const dueDateString = moment.utc(earliestPO.DueDate).format(AppConstant.commonStrings.YYYY_MM_DD);       
    //                  dueDate = moment.tz(dueDateString, masterPO?.WarehouseData?.TimeZone);
    //                 setEarliestInfo({
    //                     date: dueDate.format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat),
    //                     po: earliestPO.PoNumber,
    //                 });
    //                 setDueDateStr(dueDateString)
    //             } else {
    //                 const dueDateString = moment.utc(masterPO.DueDate).format(AppConstant.commonStrings.YYYY_MM_DD);
    //                  dueDate = moment.tz(dueDateString, masterPO?.WarehouseData?.TimeZone);
    //                   setDueDateStr(dueDateString)
    //             }
    //             setDueDate(dueDate);
    //             // Determine maxDate based on the logic
    //             let maxDate;
    //             if (OverdueBookingAllowed) {
    //                 maxDate = moment(dueDate).add(OverdueBookingAllowedDays, 'days');
    //             } else if (dueDate.endOf('day').isSameOrAfter(apptStartTime)) {
    //                 // if dueDate is same or after todayDate - bascically dueDate is in future
    //                 if (dueDate.endOf('day').isSameOrAfter(todayDate)) {
    //                     maxDate = dueDate.endOf('day'); // Due date is used
    //                 } else {
    //                     // if dueDate is before todayDate - bascically dueDate is in past
    //                     maxDate = moment(apptStartTime).add(apptLeadTime, 'hours').endOf('day'); // 
    //                 }
    //             } else {
    //                 // Unscheduled orders - Consider DueDate
    //                 if (!apptStartTime) {
    //                     maxDate = dueDate.endOf('day'); // Due date is used
    //                 } else {
                        
    //                     maxDate = moment(apptStartTime).add(apptLeadTime, 'hours').endOf('day'); // Appointment start + lead time
    //                 }
    //             }
             
    //         setSelectedDate(new Date(todayDate.year(), todayDate.month(), todayDate.date()));
    //         setMinDate(new Date(todayDate.year(), todayDate.month(), todayDate.date()));
    //         setMaxDate(new Date(maxDate.year(), maxDate.month(), maxDate.date(), 23, 59, 59));
    //             setRequestedTime(moment(todayDate).format(AppConstant.commonStrings.HH_mm_dateFormat));
    //         }
    //         setParticularFieldValue({ carrier_name: masterPO?.IDCarrier })
    //         if (masterPO?.WarehouseData?.TimeZone) {
    //             const text = masterPO?.WarehouseData?.TimeZoneDescription + ', ' + masterPO?.WarehouseData?.TimeZone
    //             setTimeZoneText(text)
    //             // moment.tz.setDefault(masterPO?.WarehouseData?.TimeZone); // Set Default Timezone
    //             //setTimezone(masterPO?.WarehouseData?.TimeZone)
    //         }

    //     }
    //     // dispatch({ type: sagaActions.CLEAR_APPOINTMENT });
    // }, [])

    useEffect(() => {
        // setLoading(true)
        setSearchableSelectFormData(null)
        setParticularFieldValue({})
        setSelectedCarrier(null)
        setEarliestInfo(null);
        setCarrierSCAC(null);
        dispatch({ type: sagaActions.SS_CLEAR_CARRIER_LIST })
        setCarrierListState([])
        if (!_.isEmpty(addCarrierSpro)) {
            dispatch({type: sagaActions.ADD_CARRIER_SCHEDULE_PRO, payload: {type: 'C'}})
        }
        if (poForAppt && poForAppt.length) {
            const masterPO = poForAppt[0];
            if (masterPO?.IDCarrier) {
                setSelectedCarrier({
                    label: masterPO?.CarrierName,
                    value: masterPO?.IDCarrier,
                })
                setSearchableSelectFormData({
                    label: masterPO?.CarrierName,
                    value: masterPO?.IDCarrier,
                })
                // setParticularFieldValue({ carrier_name: masterPO?.IDCarrier })
                setParticularFieldValue(prev => ({
                ...prev, carrier_name: masterPO?.IDCarrier }))
                
            }
            if (masterPO?.SCAC) {
                setCarrierSCAC(masterPO?.SCAC);
                setParticularFieldValue(prev => ({
                ...prev, carrier_scac: masterPO?.SCAC }))
                setIsScacDisabled(true)
            }
            const todayDate = moment().utc();
            if (isCarrier() && poForAppt.length && poForAppt[0]?.AppointmentBookStartTime) {
                const appointmentBookStartTime = poForAppt[0]?.AppointmentBookStartTime ? moment(poForAppt[0]?.AppointmentBookStartTime).utc() : null;
                let minDate;
            //  SPRO-100 - Instead of today date chnaged to apptStartTime
                if (appointmentBookStartTime.startOf('day').isSameOrAfter(todayDate.startOf('day'))) {
                    minDate = appointmentBookStartTime.startOf('day')
                } else {
                    minDate = todayDate.startOf('day')
                }
                setRequestedTime(moment(minDate).format(AppConstant.commonStrings.HH_mm_dateFormat));
            }
            else {
                setSelectedDate(new Date(todayDate.year(), todayDate.month(), todayDate.date()));
                setRequestedTime(moment(todayDate).format(AppConstant.commonStrings.HH_mm_dateFormat));
            }
            setParticularFieldValue({ carrier_scac: masterPO?.SCAC, carrier_name: masterPO?.IDCarrier })
            if (masterPO?.WarehouseData?.TimeZone) {
                const text = masterPO?.WarehouseData?.TimeZoneDescription + ', ' + masterPO?.WarehouseData?.TimeZone
                setTimeZoneText(text)
            }
        }
       
        return () => {
        dispatch({ type: sagaActions.SS_CLEAR_CARRIER_LIST })
        setCarrierListState([])
        setShowStandingPopup(false)    
        }
        // dispatch({ type: sagaActions.CLEAR_APPOINTMENT });
    }, [])
    useEffect(() => {
        if (poForAppt && poForAppt.length > 0) {
            const { minDate, maxDate, dueDate, dueDateStr, earliestInfo, OverdueBookingAllowed, OverdueBookingAllowedDays,apptLeadTime, ShowReasonCodeWindow, ShowReasonCodeWindowPost } = calculateDateRanges(poForAppt, whMetaDocksList, isCarrier());
            setMinDate(minDate);
            setMaxDate(maxDate);
            setDueDate(dueDate);
            setDueDateStr(dueDateStr);
            setEarliestInfo(earliestInfo);
            setOverdueBookingAllowed(OverdueBookingAllowed);
            setOverdueBookingAllowedDays(OverdueBookingAllowedDays);
            setShowReasonCodeWindow(ShowReasonCodeWindow);
            setShowReasonCodeWindowPost(ShowReasonCodeWindowPost);
            setSelectedDate(minDate)
            // if (isCarrier()) {
            // }
        }
    }, [poForAppt]);

    useEffect(() => {
        if (_.size(appointmentList) && intiateAppointmentLoading && appointmentConfirmation) {
            props.callSuccessPage();
            dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: false })
            dispatch({ type: sagaActions.INITIATE_SS_APPOINTMENT_LOADER, payload: false })
              //Added before PROD release sprint -36, 04/18/2024
            dispatch({type: sagaActions.ADD_APPOINTMENT_CONFIRMATION,payload: false});
        }
          //Commebted before PROD release sprint -36, 04/18/2024
        // else if (_.size(appointmentList) && intiateAppointmentLoading) {
        //     dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: false })
        //     dispatch({ type: sagaActions.INITIATE_SS_APPOINTMENT_LOADER, payload: false })
        // }
    }, [appointmentList])

    useEffect(() => {
        if (!intiateAppointmentLoading && loading) {
            dispatch({ type: sagaActions.INTIATE_SS_LOADER, payload: false })
            dispatch({ type: sagaActions.INITIATE_SS_APPOINTMENT_LOADER, payload: false })
            setLoading(false)
        }
    }, [intiateAppointmentLoading])

    useEffect(() => {
        if (_.size(poForAppt) && selectedDate) {
           const warehouseTimeZone = poForAppt[0]?.WarehouseData?.TimeZone;
             
             // Create a UTC moment from the selectedDate's components
            const selectedUTC = moment.utc([selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()]);
            const dueUTC = moment.utc(dueDate).startOf('day');

            // Check if date is after due date (post-due)
            const isAfterDueDate = selectedUTC.isAfter(dueUTC, 'day');
            const isBeforeDueDate = selectedUTC.isBefore(dueUTC, 'day');

            let shouldShowDisclaimer = false;
            let disclaimerType = null;

            if (showReasonCodeWindow > 0 && showReasonCodeWindowPost > 0) {
                const reasonCodeStartDate = dueUTC.clone().subtract(showReasonCodeWindow, 'days');
                const reasonCodeEndDate = dueUTC.clone().add(showReasonCodeWindowPost, 'days');
                if (isBeforeDueDate && selectedUTC.isBefore(reasonCodeStartDate, 'day')) {
                    shouldShowDisclaimer = true;
                    disclaimerType = 'pre';
                } else if (isAfterDueDate && selectedUTC.isAfter(reasonCodeEndDate, 'day')) {
                    shouldShowDisclaimer = true;
                    disclaimerType = 'post';
                }
            }
            else if (showReasonCodeWindow > 0 && showReasonCodeWindowPost === 0) {
                const reasonCodeStartDate = dueUTC.clone().subtract(showReasonCodeWindow, 'days');
                if ((isBeforeDueDate && selectedUTC.isBefore(reasonCodeStartDate, 'day')) || isAfterDueDate) {
                    shouldShowDisclaimer = true;
                    disclaimerType = isAfterDueDate ? 'post' : 'pre';
                }
            }
            else if (showReasonCodeWindow === 0 && showReasonCodeWindowPost > 0) {
                const reasonCodeEndDate = dueUTC.clone().add(showReasonCodeWindowPost, 'days');
                if (isBeforeDueDate || (isAfterDueDate && selectedUTC.isAfter(reasonCodeEndDate, 'day'))) {
                    shouldShowDisclaimer = true;
                    disclaimerType = isBeforeDueDate ? 'pre' : 'post';
                }
            }
            else if (showReasonCodeWindow === 0 && showReasonCodeWindowPost === 0) {
                if (isBeforeDueDate) {
                    shouldShowDisclaimer = true;
                    disclaimerType = 'pre';
                } else if (isAfterDueDate) {
                    shouldShowDisclaimer = true;
                    disclaimerType = 'post';
                }
            }

            setShowDueDateDisclaimer(shouldShowDisclaimer);
            setDueDateDisclaimerType(disclaimerType);
            setTimeSlot('')
            setRequestedTime(moment(todayDate).utc().format(AppConstant.commonStrings.HH_mm_dateFormat))
            const poObj = poForAppt[0];
            if(poObj.IDDock){
            dispatch({type:sagaActions.VALIDATE_DATE_FOR_APPOINTMENT , payload: { "selectedDate": moment(selectedDate).tz(moment.tz.guess()).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss), "IDWarehouse":poObj.IDWarehouse,"IDDock":poObj.IDDock}})
            }
            fetchRecommendationsArr();
        }
    }, [selectedDate, poForAppt,vehicleAndLoadType, dueDate, showReasonCodeWindow, showReasonCodeWindowPost])
    useEffect(() => {

        if (ssRecommendationsArr && ssRecommendationsArr.length) {
            setLoading(true)
            setRecommendationsArr(_.sortedUniq(ssRecommendationsArr))
            setErrorMsg(null)
            setLoading(false)
            // Standing slots detection
             const foundStanding = ssRecommendationsArr.filter(
                 el => el?.RecommendationType === 'STANDING'
             );
  if (foundStanding.length > 0 && !standingPopupDismissed && hasInitialFetchDone.current) {
             setStandingSlots(foundStanding);
                 setShowStandingPopup(true);
	             }
        } else {

            if (ssRecommendationsArr.length === 0) {
                setErrorMsg(AppConstant.smartScheduler.recommendations.noRecommendationWarningText)
                setRecommendationsArr([])
            }
            else {
                setErrorMsg(ssRecommendationsArr.RESULT)
                setRecommendationsArr([])
            }
            setLoading(false)
        }

    }, [ssRecommendationsArr])

    /**
   * useEffect: after a standing slot is selected, wait for SelectReccSlot state
      * to be updated then call submitHandler to move to the next screen.
      */
     useEffect(() => {
         if (pendingStandingSubmit && !_.isEmpty(SelectReccSlot)) {
             setPendingStandingSubmit(false);
             submitHandler();
         }
	     }, [pendingStandingSubmit, SelectReccSlot])

     /**
    * useEffect to call fetch Carrier data function
    */
    useEffect(() => {
        if (_.size(carrierList) && !isCarrier()) {
            formCarrierListData();
        }
    }, [carrierList]);

    /**
     * UseEffect of add carrier SPro
     */

    useEffect(() => {
        if (!_.isEmpty(addCarrierSpro)) {
            setCarrierListState([...carrierListState, {value:addCarrierSpro?.carrier_id, label: addCarrierSpro?.carrier_name }])
            setSelectedCarrier({
                value: addCarrierSpro?.carrier_id,
                label: addCarrierSpro?.carrier_name
            })
            setSearchableSelectFormData({
                value: addCarrierSpro?.carrier_id,
                label: addCarrierSpro?.carrier_name
            })
            setParticularFieldValue({ carrier_name: addCarrierSpro?.carrier_id })
            bookAppt( addCarrierSpro?.carrier_id)
            dispatch({type: sagaActions.ADD_CARRIER_SCHEDULE_PRO, payload: {type: 'C'}})
        }

    }, [addCarrierSpro])


    const fetchRecommendationsArr = () => {
        if (!_.isEmpty(vehicleAndLoadType)) {
            const poObj = poForAppt[0];
            // We need send po with comma separated to BE to handle multiple PO's on BE
            let allPOs = ''
            poForAppt.forEach((el) => {
                allPOs = allPOs + el.PoNumber + ",";
                return;
            });
            const apiParams = {
                "IDWarehouse": poObj.IDWarehouse,
                "IDDock": poObj.IDDock,
                "PoNumber": allPOs,
                // "selectedDate": jsDateObjToUTC(selectedDate),
                // moment.tz.guess() This is added to keep the calendar time same as user timezone and send same data to Backend
                "selectedDate": moment(selectedDate).tz(moment.tz.guess()).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss),
                "requestedTime": requestedTime,
                "RequestedBy": cu_id,
                "vehicleType": vehicleAndLoadType && vehicleAndLoadType.vehicleType ? vehicleAndLoadType.vehicleType : "",
                "orderType": vehicleAndLoadType && vehicleAndLoadType.loadType ? vehicleAndLoadType.loadType : "",
                "IDCarrier": userType === AppConstant.userPermission.usertypes.carrier ? userAccountDetails?.IDCarrier : poObj?.IDCarrier
            }
            if (selectedDate && requestedTime) {
                dispatch({ type: sagaActions.SS_RECOMMENDATIONS_LIST_ACTION, payload: { ...apiParams } })
       hasInitialFetchDone.current = true;
            }
        }
    }


    const getIDCarrier = ({
  carrier_name,
  selectedCarrier,
  userType,
  userAccountDetails,
    }) => {
  const isCarrierUser =
    userType === AppConstant.userPermission.usertypes.carrier;

        const defaultCarrier = userAccountDetails?.IDCarrier;
        
        if (isCarrierUser) {
            if (carrier_name) {
                return carrier_name === defaultCarrier
                    ? carrier_name
                    : defaultCarrier;
            }
      
            if (!_.isEmpty(selectedCarrier)) {
                return selectedCarrier?.value === defaultCarrier
                    ? selectedCarrier.value
                    : defaultCarrier;
            }
      
            return defaultCarrier;
        } else {
            if (carrier_name) {
                return carrier_name;
            }
            else if (!_.isEmpty(selectedCarrier)) {
                return selectedCarrier?.value || selectedCarrier;
            }
        }

    };
    
    const bookAppt = (carrier_name) => {
        setLoading(true);
        dispatch({ type: sagaActions.INITIATE_SS_APPOINTMENT_LOADER, payload: true })
        const payload_door = SelectReccSlot.TimeSlotName;
        const payload_IDDock = poForAppt[0].IDDock;
        let CRUDTYPE = 'I';
        const fieldData = formParticularFieldValue(poForAppt);
        let poNum = fieldData?.po_number;
        // if (!poNum.includes(",")) {
            poNum = poNum + ",";
        // }

        const masterPO = poForAppt[0];
        if (_.upperCase(masterPO?.ApptScheStatus) === _.upperCase('Scheduled') || _.upperCase(masterPO?.ApptScheStatus) === _.upperCase('Rescheduled') || _.upperCase(masterPO?.ApptScheStatus) === _.upperCase('Completed')) {
            CRUDTYPE = 'R'
        }
        // let selectedStartTimeData = formTime(moment(SelectReccSlot.ApptStartTime).utc().format(AppConstant.commonStrings.MM_DD_YYYY__HH_mm_ss))
        let selectedStartTimeData = SelectReccSlot.ApptStartTime
        const newItemPayload = {
            PoNumber: poNum,
            IDWarehouse: masterPO?.IDWarehouse,
            ReceivingZipCode: masterPO?.ReceivingZipCode,
            ApptStartDate: selectedStartTimeData,
            ApptStartTime: selectedStartTimeData,
            ApptEndDate: null,
            ApptEndTime: null,
            ApptStatus: 1,
            Door: payload_door,
            ApptCreatedBy: cu_id,
            IDDock: SelectReccSlot.IDDock,
            // IDDock: payload_IDDock ? payload_IDDock : SelectReccSlot.IDDock,
            IDCarrier: getIDCarrier({
                carrier_name,
                selectedCarrier,
                userType,
                userAccountDetails,
            }),
            CRUDTYPE: CRUDTYPE,
            DeletedPos: '',
            isManualOverride: false,
            rescheduleReason: CRUDTYPE === 'R' ? rescheduleReason : null,
            appointmentDocumentsList: appointmentDocumentsList,
            userType: userType,
            "vehicleType":vehicleAndLoadType && vehicleAndLoadType.vehicleType ? vehicleAndLoadType.vehicleType : "", 
            "orderType": vehicleAndLoadType && vehicleAndLoadType.loadType ? vehicleAndLoadType.loadType : "",
            OverDueBookingReason: overDueWindowReason || null,
            RecommendationType: SelectReccSlot?.RecommendationType || null
        }
        if(CRUDTYPE==='R'){ 
         newItemPayload.PORelationID=masterPO.PORelationID;
         newItemPayload.vehicleType=masterPO?.vehicleType;
         newItemPayload.orderType=masterPO?.orderType
        }
        dispatch({ type: sagaActions.ADD_APPOINTMENT, payload: newItemPayload })
        dispatch({
            type: sagaActions.ADD_SELECTED_DATE_FOR_APPT_UPDATE,
            payload: new Date(),
        });
    }

    /**
     * Shared helper: checks whether the selected date falls within the due-date
     * reason-code window and either calls `onProceed` directly or opens the
     * overdue-window reason popup.  Extracted to satisfy DRY — used by both the
     * submit button onClick and handleStandingSlotSelect.
     */
    const checkDateAndProceed = (onProceed) => {
        const selectedUTC = moment.utc([selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()]);
        const dueUTC = moment.utc(dueDate).startOf('day');

        // No popup on the due date itself
        if (selectedUTC.isSame(dueUTC, 'day')) {
      onProceed();
          return;
        }

        // If a reason code window is defined
    if (showReasonCodeWindow > 0 || showReasonCodeWindowPost > 0) {
    const reasonCodeStartDate = dueUTC.clone().subtract(showReasonCodeWindow, 'days');
            const reasonCodeEndDate = dueUTC.clone().add(showReasonCodeWindowPost, 'days');

            if (selectedUTC.isSameOrAfter(reasonCodeStartDate, 'day') && selectedUTC.isBefore(dueUTC, 'day')) {
            onProceed();
     } else if (selectedUTC.isAfter(dueUTC, 'day') && selectedUTC.isSameOrBefore(reasonCodeEndDate, 'day')) {
     onProceed();
     } else {
           openOverWindowPopupHandler();
        }
        } else {
   // Fallback: If no window is defined, show popup for any date that is not the due date
            if (!selectedUTC.isSame(dueUTC, 'day')) {
      openOverWindowPopupHandler();
            } else {
      onProceed();
 }
        }
    };

    const openOverWindowPopupHandler = () => {
        if (!overDueWindowReason && !showOverDueWindowReasonPopup) {
          setShowOverDueWindowReasonPopup(true)
 }
    }

    const submitHandler = () => {
        if (isCarrier()) {
            bookAppt()
        } else {
            // This is WAREHOUSE FLOW
            setNextStep(true)
            if (_.size(poForAppt)) {
                const masterPO = poForAppt[0];
                if (masterPO?.IDCarrier) {
                    setSelectedCarrier({
                        label: masterPO?.CarrierName,
                        value: masterPO?.IDCarrier,
                    });
                    setParticularFieldValue({ carrier_name: masterPO?.IDCarrier, carrier_scac: masterPO?.SCAC })
                    setCarrierSCAC(masterPO?.SCAC);
                    setIsScacDisabled(true)
                } else {
                    setSelectedCarrier({})
                }
            }
        }
    }

    const displayLoader = (themeSelected, height, count) => {
        return (
            <Loader height={height || 35} count={count || 1} highlightColor={themeSelected === 'dark-mode' ? '#151515' : ''}
                baseColor={themeSelected === 'dark-mode' ? '#575757'
                    : ''}
            />
        )
    }


    const handleTimeSlotClick = (e, data) => {
        setSelectReccSlot(data)
    }

    const formCarrierListData = () => {
        if (_.size(carrierList)) {
            const carrierData = carrierList.map((el) => {
                return {
                    value: el.carrier_id,
                    label: el.carrier_name
                };
            });
            setCarrierListState([...carrierData]);
        } else {
            setCarrierListState([]);
        }
    };

    const onCarrierSelcted = (props) => {
        dispatch({ type: sagaActions.SS_CLEAR_CARRIER_LIST })
        setCarrierListState([])
        if (props.length > 2) {
            dispatch({
                type: sagaActions.SS_GET_CARRIER_LIST,
                payload: { carrier: props },
            });
        }
    };

    const onCreateSelected = (carrierName) => {

    // const payload = {
    //         name: carrierName,
    //         SCAC: null,
    //         contact_phone: null,
    //         first_name: null,
    //         last_name: null,
    //         type: 'A'
    //     };

    //     dispatch({
    //         type: sagaActions.ADD_CARRIER_SCHEDULE_PRO,
    //         payload
    //     });

        setSelectedCarrier({
            label: carrierName,
            value: null
        });
        setSearchableSelectFormData({
            value: null,
            label: carrierName
        })

        setCarrierSCAC("");
        setParticularFieldValue(prev => ({
            ...prev,
            carrier_scac: '',
            carrier_name: carrierName
        }));
        setIsScacDisabled(false);
};

const formFieldList = [
    {
        name: "carrier_name",
        type: "select_with_input_search_add_button_temp",
        size: "col-sm-8 mb-3 f-12",
        parentClass: "inputTitle",
        componentClassName: "mt-1 inputDiv border border-1 rounded-1 border-dark",
        inputTitle: "Select Carrier",
        title: AppConstant.reports.scheduledLoadStatus.tableHeaders.carrierName,
        customStylesLight: customStylesLight,
        placeholderText: "Select a carrier from the list",
        onInputChange: onCarrierSelcted,
        defaultValue: !_.isEmpty(selectedCarrier)
            ? selectedCarrier
            : "Select a carrier from the list",
        isClearable: false,
        isSearchable: true,
        options: carrierListState,
        formValidation: { required: true },
        handleCreateOption: onCreateSelected,
        searchableSelectFormData: searchableSelectFormData,
    },
    {
        name: "carrier_scac",
        type: "text",
        size: "col-sm-4 mb-3 f-12",
        parentClass: "inputTitle",
        componentClassName: "mt-1 inputDiv border border-1 rounded-1 border-dark",
        inputTitle: "SCAC Code (Optional)",
        title: "SCAC Code",
        placeholderText: "Enter SCAC Code",
        defaultValue: carrierSCAC
            ? carrierSCAC
            : "Enter SCAC Code",
        value: carrierSCAC,
        disabledField: isScacDisabled,
        onChange: (value) => setCarrierSCAC(value),
        formValidation: {
            required: true
        }
    }
];
    const submitbtnData = {
        show: true,
        text: AppConstant.commonStrings.submit,
    };
    const custombtnData = {
        show: true,
        text: 'Back',
    };

    const customBtnHandler = (e, type) => {
        if (type === 'customBtn') {
            setNextStep(false)
            setResetFormData(0)
            setSelectedCarrier(null)
            setSelectReccSlot(null)
            setOverDueWindowReason(null)
            setShowOverDueWindowReasonPopup(false)
        }
    }

    const getSummitedFormData = (data) => {
    
    const carrierId = data?.carrier_name;
    // const enteredSCAC = carrierSCAC?.trim();
        // const enteredSCAC = data?.carrier_scac || carrierSCAC?.trim();

        const enteredSCAC = (data?.carrier_scac ?? carrierSCAC ?? "").trim();

        if (enteredSCAC && enteredSCAC.length !== 4) {
            showAlert(toast .TYPE.ERROR, 'Scac code should be 4 characters only');
    return;
}

        
    // If SCAC entered and not already existing
    if (enteredSCAC && !isScacDisabled) {

        const payload = {
            name: searchableSelectFormData?.label,
            SCAC: enteredSCAC,
            contact_phone: null,
            first_name: null,
            last_name: null,
            type: 'A'
        };

        dispatch({
            type: sagaActions.ADD_CARRIER_SCHEDULE_PRO,
            payload
        });

        // bookAppt(carrierId);

    } else {
        bookAppt(carrierId);
    }
};



const getFormFieldData = (
    data,
    name,
    control,
    inputs,
    searchableSelectFormData
) => {

    if (name === "carrier_name") {

        setSelectedCarrier(data);

        if (searchableSelectFormData) {
            setSearchableSelectFormData(searchableSelectFormData);
        }

        // Find selected carrier full object
        const selectedCarrierObj = carrierList?.find(
            el => el.carrier_id === searchableSelectFormData?.value
        );
        if (selectedCarrierObj?.SCAC) {
            setCarrierSCAC(selectedCarrierObj.SCAC);
            setIsScacDisabled(true);
            setParticularFieldValue(prev => ({
                ...prev,
                carrier_scac: selectedCarrierObj.SCAC,
                carrier_name: searchableSelectFormData?.value

            }));
        } else {
            setCarrierSCAC("");
            setParticularFieldValue(prev => ({
                ...prev,
                carrier_scac: '',
                carrier_name: searchableSelectFormData?.value
            }));
            setIsScacDisabled(false);
        }
        dispatch({ type: sagaActions.SS_CLEAR_CARRIER_LIST })
        setCarrierListState([])
    }
};

    const openForm = () => {
        return <CustomDynamicFormSS
            formFieldList={formFieldList}
            sort={true}
            submitbtn={submitbtnData}
            themeSelected={themeSelected}
            getFormFieldData={getFormFieldData}
            getSummitedFormData={getSummitedFormData}
            // editFormData={editData}
            loading={intiateAppointmentLoading}
            resetFormData={() => {
                setResetFormData(0)
                setSelectedCarrier(null)
                setSelectReccSlot(null)
            }}
            setParticularFieldValue={particularFieldValue}
            disclaimer={true}
            disclaimersArray={[{ text: "If SCAC code is not available, kindly enter NANA" }]}
            customDisableSave={false}
            customBtn={custombtnData}
            customBtnHandler={customBtnHandler}
        />
    }

    const handleClose = () => {
        setShowOverDueWindowReasonPopup(false)
        // setCloseModal(false)
    };
    

    const getOverdueWindowPopupBody = () => {
        const poObj = poForAppt[0];
        return (
            <SelectRescheuleReason rescheduleReason={overDueWindowReason} setRescheduleReason={setOverDueWindowReason} onSubmit={() => {
                setShowOverDueWindowReasonPopup(false)
            }} type='Cancel' errorMsg={errorMsg} IDWarehouse={poObj?.IDWarehouse} showTitle={false} />
        )
    }

     const overdueWindowPopupObj = {
            id: "overdueWindowPopup",
            modalLabel: "overdueWindowPopup",
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: "md",
            title: 'Select reason for scheduling outside due date',
            bodyText: getOverdueWindowPopupBody(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            alignType: 'center',
            type: 'info',
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.submit,
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.cancel,
                },
            },
    }
    
    const overdueWindowPopupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.submit && overDueWindowReason) {
            setShowOverDueWindowReasonPopup(false)
            submitHandler();
        } else {
            setOverDueWindowReason(null)
            setShowOverDueWindowReasonPopup(false)
            showAlert(toast.TYPE.ERROR, 'You need to select a reason before proceeding futher with appointment booking.');

        }
    }

    // Standing popup helpers
     const handleStandingPopupClose = () => {
         setShowStandingPopup(false);
         setStandingPopupDismissed(true);
     };
 
     const handleStandingSlotSelect = (slot) => {
         setSelectReccSlot(slot);
         setShowStandingPopup(false);
         setStandingPopupDismissed(true);
         checkDateAndProceed(() => setPendingStandingSubmit(true));
     };
 
     const getStandingPopupBody = () => {
         return (
             <div className='standing-popup-body'>
                 <div className='standing-popup-intro'>
                     <div className='standing-popup-icon-ring'>
                         <i className='fa-solid fa-thumbtack'></i>
                     </div>
                     {selectedDate && (
                         <p className='standing-popup-date'>
                             <i className='fa-regular fa-calendar me-1'></i>
                             <strong>{moment(selectedDate).tz(moment.tz.guess()).format('dddd, MMMM Do YYYY')}</strong>
                         </p>
                     )}
                     {poForAppt && poForAppt.length > 0 && (
                         <div className='standing-popup-fpr'>
                             <span className='standing-popup-fpr-label'>PO/SO: </span>
                             <span
                                 className='standing-popup-fpr-value'
                                 title={poForAppt.map(po => po.PoNumber).join(', ')}
                             >
                                 {poForAppt.length > 3
                                     ? poForAppt.slice(0, 3).map(po => po.PoNumber).join(', ') + ' +' + (poForAppt.length - 3) + ' more'
                                     : poForAppt.map(po => po.PoNumber).join(', ')}
                             </span>
                         </div>
                     )}
                     <p className='standing-popup-subtitle'>
                         These slots are <strong>pre-assigned fixed windows</strong> for this dock. You can pick one directly or continue choosing from all available slots.
                     </p>
                 </div>
                 <div className='standing-slots-list'>
                     {standingSlots.map((slot, idx) => (
                         <div
                             key={idx}
                             className='standing-slot-card'
                             onClick={() => handleStandingSlotSelect(slot)}
                         >
                             <div className='standing-slot-card-left'>
                                 <span className='standing-slot-card-icon'>
                                     <i className='fa-regular fa-clock'></i>
                                 </span>
                                 <div>
                                     <p className='standing-slot-card-time'>
                                         {slot.ApptStartTime
                                             ? moment(slot.ApptStartTime).utc().format(AppConstant.commonStrings.hh_mm_A_dateFormat)
                                             : '-'}
                                     </p>
                                     <p className='standing-slot-card-dock'>
                                         Dock: <strong>{slot.DockName || '-'}</strong>&nbsp;
                                     </p>
                                     {/* <p className='standing-slot-card-dock'>
           Dock: <strong>{slot.DockName || '-'}</strong>&nbsp;&middot;&nbsp;Slot: <strong>{slot.TimeSlotName || '-'}</strong>
        </p> */}
                                 </div>
                             </div>
                             <span className='standing-select-btn'>Select &rarr;</span>
                         </div>
                     ))}
                 </div>
                 <p className='standing-popup-disclaimer'>
                     <i className='fa-solid fa-circle-info me-1'></i>
                     Fixed slots are pre-configured recurring windows. Selecting one will pre-fill your time slot. You may still choose a different slot from the main list.
                 </p>
             </div>
         );
     };
 
     const standingPopupObj = {
         id: 'standingPopup',
         modalLabel: 'standingPopup',
         showClose: true,
         showfooter: true,
         showHeader: true,
         sendDriverNotification: false,
         modalSize: 'md',
         title: '📌 Fixed Slots Found — Want to use them?',
         bodyText: getStandingPopupBody(),
         subText: '',
         keyboard: false,
         backdrop: 'static',
         alignType: 'start',
         headerAlign: 'start',
         type: 'info',
         footerBtn: {
             btn1: {
                 show: true,
                 text: 'Continue with Recommendations',
             },
             btn2: {
                 show: true,
                 text: 'Dismiss',
             },
         },
     };
 
     const standingPopupBtnHandler = (text) => {
         // Both footer buttons simply close the popup and let the user pick from the main list
         handleStandingPopupClose();
	     };

    return (<>
        {!nextStep ? <div>
            <div className='d-flex justify-content-between recommendation-wrapper gap-3 w-100'>
                <div className='calender-wrapper'>
                    <p className='fw-semibold p-2 text-start'>Select Date & Time</p>
                    <div className=''>
                        <DatePickerSS minDate={minDate} maxDate={maxDate} dueDate={dueDateStr} setSelectedDate={setSelectedDate} selectedDate={selectedDate} setLoading={false} OverdueBookingAllowed={overdueBookingAllowed} ShowReasonCodeWindow={showReasonCodeWindow} ShowReasonCodeWindowPost={showReasonCodeWindowPost} />
                    </div>
                    {dateValidationResponse && !dateValidationResponse.Leaves.valid ?
                <p className='f-12 color-red fw-400 text-start'>* {dateValidationResponse?.Leaves?.message}</p>
            :""}
                   {earliestInfo && (
               <p className='color-red ss-timezone f-10 text-start'>
                   * The earliest due date has been set for this appointment. The due date is {earliestInfo.date} and PO/SO is {earliestInfo.po}
               </p>
                    )}
                    {showDueDateDisclaimer && dueDateDisclaimerType === 'post' &&
                        <p className='my-1 ss-timezone f-8 color-red text-start'>* This PO is after the scheduled window. Vendor Compliance charge may apply. Please provide a reason for late delivery.</p>
                    }
                    {showDueDateDisclaimer && dueDateDisclaimerType === 'pre' &&
                        <p className='my-1 ss-timezone f-8 color-red text-start mb-2'>* This PO is before the scheduled window. Vendor Compliance charge may apply. Please provide a reason for early delivery.</p>
                    }
               </div>
                <div className='overflowX-hidden w-inherit timeslots-container-ss'>
                    {!intiateAppointmentLoading ?
                        <RecommendedTimeslotSS selectedDate={selectedDate} ssRecommendationsArr={ssRecommendationsArr} loading={loading} errorMsg={errorMsg} handleTimeSlotClick={(e, el) => handleTimeSlotClick(e, el)} timeSlot={SelectReccSlot} />
                        :
                        displayLoader(themeSelected, 30, 10)
                    }

                </div>
            </div>
            <div className='d-flex justify-content-between flex-wrap mt-1 mb-2'>
                <div>
                    <p className='ss-timezone'>
                        Time Zone:
                    </p>
                    <p className='ss-timezone-sub'>
                        {timeZoneText}
                    </p>
                </div>
                <div>
                {!isCarrier()&&
                <CustomButtonSS
                    isLoading={false}
                    title={'Back'}
                    className={ "btn-unstyled"}
                        onClick={() => {
                            {
                                setOverDueWindowReason(null)
                                setShowOverDueWindowReasonPopup(false)
                                handleOptionChangeParent('')
                            }
                        }}
                />}
                <CustomButtonSS
                    isLoading={intiateAppointmentLoading}
                    title={isCarrier() ? AppConstant.commonStrings.submit : AppConstant.commonStrings.next}
                    className={_.isEmpty(SelectReccSlot) ? "btn-submit disabled" : "btn-submit"}
                         onClick={() => checkDateAndProceed(submitHandler)}
                    disabled={_.isEmpty(SelectReccSlot) || errorMsg ? true : false}
                />
                </div>
            </div>

        </div> : <>
            <div className='p-3'>
                <div className='d-flex justify-content-start boldText'>
                    <div>
                        <p className=''>You are booking an appointment for: </p>

                        <div className='bolderText my-2'><i className="fa-regular fa-clock"></i> {moment(SelectReccSlot.ApptStartTime).utc().format('dddd')}, {moment(SelectReccSlot.ApptStartTime).utc().format(AppConstant.commonStrings.MMMM_Do)} <span className='fw-normal'>&nbsp;{moment(SelectReccSlot.ApptStartTime).utc().format(AppConstant.commonStrings.hh_mm_A_dateFormat)}</span></div>
                    </div>
                </div>
                <div className='min-h-32 d-flex flex-column justify-content-around'>

                    {openForm()}
                </div>
                </div>
        </>
        }
        {showOverDueWindowReasonPopup ? <SSPopup {...overdueWindowPopupObj} popupBtnHandler={(text) => overdueWindowPopupBtnHandler(text)} closepopup={handleClose} themeSelected={themeSelected} showModal={showOverDueWindowReasonPopup} /> : ''}
         {showStandingPopup ? <SSPopup {...standingPopupObj} popupBtnHandler={(text) => standingPopupBtnHandler(text)} closepopup={handleStandingPopupClose} themeSelected={themeSelected} showModal={showStandingPopup} /> : ''}
    </>
    )
}
